// 画像を表示する関数
function showImage() {
  let img = document.getElementById('logo-image');

  // 既存の画像がなければ作成して追加
  if (!img) {
      img = document.createElement('img');
      img.id = 'logo-image';
      img.src = 'https://goodspeed-online.myshopify.com/cdn/shop/files/logo.png'; // 表示したい画像のパス
      img.alt = 'GOOD SPEED'; // 代替テキスト
      img.style.maxWidth = '80%'; // スタイルを調整

      // 画像を挿入する場所を選択
      const targetElement = document.querySelector('.mobile-nav-title'); // 適切な親要素のIDを指定
      if (targetElement) {
          targetElement.appendChild(img);
      } else {
          console.warn('Target container not found.');
      }
  } else {
      // 非表示の場合は再表示
      img.style.display = 'block';
  }
}

// 画像を非表示にする関数
function hideImage() {
  const img = document.getElementById('logo-image');
  if (img) {
      img.style.display = 'none';
  }
}

// クラスの変更を監視して表示/非表示を切り替える関数
function observeClassChanges() {
  const list = document.querySelectorAll('.mobile-navigation-drawer'); // 対象のリストのクラス名を指定

  // `MutationObserver`の設定
  const observer = new MutationObserver(() => {
      let hasHogeClass = false;

      // リスト内の要素をチェック
      list.forEach(item => {
          if (item.classList.contains('mobile-navigation-drawer--child-open')) {
              hasHogeClass = true;
          }
      });

      // `hoge` クラスの有無に応じて画像を表示/非表示
      if (hasHogeClass) {
          hideImage();
      } else {
          showImage();
      }
  });

  // 各リスト要素を監視
  list.forEach(item => {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
  });
}

// ページロード時に監視を開始
document.addEventListener('DOMContentLoaded', () => {
  observeClassChanges();
  // 初回チェック
  const initialCheck = Array.from(document.querySelectorAll('.mobile-navigation-drawer')).some(item => 
      item.classList.contains('mobile-navigation-drawer--child-open')
  );
  if (initialCheck) {
      hideImage();
  } else {
      showImage();
  }
});
